<template>
  <div>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
            type="danger"
            plain
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelete">删除</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="varDateList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="设备序号" align="center" prop="devSn" />
      <el-table-column label="点位1" align="center" prop="dianwei1" />
      <el-table-column label="检测值" align="center" prop="value1" />
      <el-table-column label="点位2" align="center" prop="dianwei2" />
      <el-table-column label="检测值" align="center" prop="value2" />
      <el-table-column label="时间" align="center" prop="ts" width="180"/>
      <el-table-column label="状态" align="center" prop="status" >
        <template slot-scope="{ row }">
          <Tag color="error" v-if="row.status===1">异常</Tag>
          <Tag color="success" v-if="row.status===0">正常</Tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; margin-top: 15px">
      <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
    </div>
  </div>

</template>

<script>
import {listVarDate,delVarDate} from "@/api/verDate/vardate"
export default {
  name: "verDate",
  data(){
    return{
      loading: true,
      varDateList: [],
      total: 0,
      curPage: 1,
      pageSize: 10,
      // 非多个禁用
      multiple: true,
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    }
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询【请填写功能名称】列表 */
    getList() {
      this.loading = true;
      listVarDate({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(response => {
        this.varDateList = response.body.data;
        this.total = response.body.cum
        this.loading = false;
      });
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    pageChange(val) {
      this.curPage = val;
      this.getList();
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$message.warning('是否确认删除【气体检测】编号为"' + ids + '"的数据项？');
      delVarDate(ids).then( res =>  {
        this.$message.success("删除成功");
        this.getList();
      })
    },
  }
}
</script>

<style scoped>

</style>